import React, {useState, useEffect} from 'react';
import Modal from 'react-modal';
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPaperPlane, faTimes } from '@fortawesome/free-solid-svg-icons';
import styles from './messaging.module.css'

const baseURL = `${process.env.REACT_APP_API_URL}`


Modal.setAppElement('#root')

const Messagingmodal = ({isOpen, onClose, recipientId, recipientName}) => {
    const [messages, setMessages] = useState([]);
    const [newMessage, setNewMessage] = useState('');
    const [loading, setLoading] = useState(false);
    const token = localStorage.getItem('accessToken');

    const fetchMessages = async () => {
        setLoading(true)
        try {
            const response = await axios.get(`${baseURL}/profiles/inbox/`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            const conversation = response.data.filter(
                (msg) => 
                    msg.sender === recipientId || msg.recipient === recipientName
            );
            console.log('message response data:', conversation)
            setMessages(conversation);
        } catch (error) {
            console.error('Error fetching messages:', error);
        }
        setLoading(false)
    };

    useEffect(() => {
        if (isOpen) {
            fetchMessages();
        }
    }, [isOpen]);


    const handleSendingMessage = async (e) => {
        e.preventDefault()
        if (!newMessage.trim()) return;
        try {
            const response = await axios.post(
                `${baseURL}/profiles/send_message/`,
                {
                    recipient: recipientId,
                    content: newMessage,
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            setNewMessage('')
            fetchMessages();
        } catch (error) {
            console.error('Error sending message:', error);
        }
    };

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={onClose}
            contentLabel='Messaging Modal'
            className={styles.modalContent}
            overlayClassName={styles.modalOverlay}
        >
            <div className={styles.modalHeader}>
                <h2>Chat with {recipientName}</h2>
                <button onClick={onClose} className={styles.closeButton}>
                    <FontAwesomeIcon icon={faTimes} />
                </button>
            </div>
            <div className={styles.messageContainer}>
                {loading ? (
                    <p>Loading Messages...</p>
                ) :  messages.length === 0 ? (
                    <p>No messages yet. start the Conversation!</p>
                ) : (
                    messages.map((msg) => (
                        <div 
                            key={msg.id}
                            className={
                                msg.sender === recipientId
                                ? styles.receivedMessage
                                : styles.sentMessage
                            }
                            >
                                <p>{msg.content}</p>
                                <small>{new Date(msg.created_at).toLocaleDateString()}</small>
                            </div>
                    ))
                )}
            </div>
            <form onSubmit={handleSendingMessage} className={styles.messageForm}>
                <input
                    type='text'
                    placeholder='Type your message...'
                    value={newMessage}
                    onChange={(e) => setNewMessage(e.target.value)}
                    className={styles.messageInput}
                />
                <button type='submit' className={styles.sendButton}>
                    <FontAwesomeIcon icon={faPaperPlane} />
                </button>
            </form>
        </Modal>
    );
};

export default Messagingmodal;